import React, { useState, useRef } from 'react';

// Utility for copying text
async function copyText(text) {
  if (navigator.clipboard) {
    await navigator.clipboard.writeText(text);
  } else {
    // Fallback
    const tmp = document.createElement('textarea');
    tmp.value = text;
    document.body.appendChild(tmp);
    tmp.select();
    document.execCommand('copy');
    document.body.removeChild(tmp);
  }
}

function CopyCell({ value, maxLength = 15 }) {
  const [showTip, setShowTip] = useState(false);
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef();

  const short = value?.length > maxLength
    ? value?.slice(0, maxLength) + '…'
    : value;

  const handleCopy = async () => {
    await copyText(value);
    setCopied(true);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div
      style={{ position: 'relative', display: 'inline-block', cursor: 'pointer' }}
      onMouseEnter={() => !copied && setShowTip(true)}
      onMouseLeave={() => setShowTip(false)}
      onClick={handleCopy}
    >
      <span>{short}</span>
      {showTip && (
        <div style={{
          position: 'absolute',
          bottom: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          marginBottom: 6,
          padding: '4px 8px',
          background: '#333',
          color: '#fff',
          fontSize: 10,
          borderRadius: 4,
          whiteSpace: 'nowrap',
          zIndex: 10
        }}>
          {copied ? 'Copied!' : 'Click to copy'}
        </div>
      )}
    </div>
  );
}

export default CopyCell;